<template>
  <nav id="sidenav">
    <header>
      <img src="@/assets/logo.png" class="logo" />
    </header>

    <ul>
      <li class="text-[9px] font-medium uppercase text-zinc-500 ml-2">
        Основные разделы
      </li>
      <li>
        <router-link :to="{ name: 'labor-cost-collection' }">
          <svg-icon name="sli-wallet" />
          Сборник сметных цен на затраты труда на работы по среднему, текущему
          ремонту и содержанию автомобильных дорог
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'machine-cost-collection' }">
          <svg-icon name="sli-car" />
          Сборник сметных цен в текущем уровне на эксплуатацию строительных
          машин и механизмов, используемых при среднем, текущем ремонте и
          содержании автомобильных дорог
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'srd' }">
          <svg-icon name="sli-layer" />
          Сборник сметных норм на работы по среднему и текущему ремонту,
          содержанию, озеленению, диагностике и паспортизации автомобильных
          дорог общего пользования и дорожных сооружений на них, а также улиц
          городов и населенных пунктов
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'technical-supervision-calculator' }">
          <svg-icon name="sli-calc" />
          Калькулятор расчета стоимости услуг технического надзора
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'settings' }">
          <svg-icon name="sli-settings" />
          Настройки
        </router-link>
      </li>
      <li v-if="user.role === 'admin'">
        <router-link :to="{ name: 'users' }">
          <svg-icon name="sli-driver" />
          Учетные записи
        </router-link>
      </li>
    </ul>
    <div
      @click="logout"
      class="cursor-pointer mt-auto bg-gray-300 p-2 rounded-md flex items-center gap-2"
    >
      <div class="w-8 h-8 rounded-full bg-gray-200"></div>
      <div>
        <div class="text-xs text-zinc-800">{{ user.email }}</div>
        <div class="text-xs text-zinc-500">{{ user.role }}</div>
      </div>
    </div>
  </nav>
  <div class="w-full h-full overflow-y-auto">
    <router-view />
  </div>
</template>

<script>
import { resourceConfig } from "@/config/resources";
import SvgIcon from "@/components/SvgIcon.vue";

export default {
  components: { SvgIcon },
  data() {
    return {};
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    catalogs() {
      return Object.keys(resourceConfig)
        .map((key) => ({
          label: resourceConfig[key].displayName,
          route: {
            name: "resource",
            params: { name: key },
          },
        }))
        .filter((item) => item.route.params.name !== "document");
    },
    sidebarMenu() {
      return this.$router.options.routes.filter((route) => route.meta?.sidebar);
    },
  },
  methods: {
    logout() {
      localStorage.removeItem("access_token");
      window.location.reload();
    },
  },
};
</script>

<style lang="scss">
html,
body {
  @apply h-full;
}
#app {
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif;

  @apply h-full w-full flex items-start;

  nav#sidenav {
    @apply w-[270px] h-full bg-zinc-50 flex-shrink-0;
    @apply border-0 border-r border-zinc-200 p-4 flex flex-col;

    .logo {
      @apply w-7;
    }

    & > ul {
      @apply text-xs mt-5 flex flex-col gap-1;
      & > li {
        & > a {
          @apply block border border-solid border-transparent rounded px-2 py-1.5;
          @apply cursor-pointer text-black;
          @apply flex items-center gap-2;

          svg {
            @apply flex-shrink-0 w-5 h-5 fill-zinc-100 text-zinc-700;
          }

          &:hover {
            @apply border-blue-200 bg-blue-50 cursor-pointer text-blue-600;
          }

          &.router-link-active {
            @apply border-blue-500 bg-blue-500 cursor-pointer text-white;

            svg {
              @apply text-white fill-none;
            }
          }
        }

        & > ul {
          @apply mt-1 ml-5;
          li {
            a {
              @apply block text-zinc-500 py-1.5;
              &.router-link-active {
                @apply text-blue-600;
              }
            }
          }
        }
      }
    }
  }
}

.srd-form-parent-select {
  @apply max-w-[460px];
}
.el-loading-mask {
  z-index: 9;
}
</style>
